<template>
  <header class="header-container position-relative overflow-hidden">
    <div class="top-box"></div>
    <div class="container">
      <div class="header p-1 d-flex  flex-md-row align-items-start align-items-md-center justify-content-between"
        :class="{ 'special-navbar': isSpecialStyling }">
        <div class="d-lg-flex flex-row gap-3 info d-none align-self-end">
          <a aria-label="phone number" href="#" target="_blank" class="social">
            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
              <path
                d="M5.58676 1.91428L6.51063 1.63641C7.01674 1.48379 7.56108 1.52053 8.04209 1.73977C8.52309 1.959 8.90791 2.34576 9.12471 2.82787L9.8388 4.41595C10.0252 4.83063 10.0771 5.29326 9.98724 5.73893C9.89737 6.18461 9.67022 6.59097 9.33767 6.90099L8.15413 8.00378C8.11956 8.036 8.09765 8.07953 8.09238 8.12649C8.05755 8.44078 8.27051 9.05274 8.76213 9.90378C9.11838 10.5221 9.44217 10.9567 9.71688 11.1997C9.90926 11.3699 10.0145 11.4064 10.0597 11.3937L11.6509 10.9068C12.0855 10.7739 12.5507 10.7803 12.9815 10.9251C13.4122 11.0699 13.7868 11.3459 14.0528 11.7143L15.0662 13.1203C15.3747 13.5478 15.5176 14.0727 15.4684 14.5976C15.4191 15.1224 15.1812 15.6116 14.7986 15.9743L14.0964 16.6393C13.7241 16.9918 13.2669 17.2419 12.7692 17.3653C12.2716 17.4886 11.7505 17.481 11.2567 17.3431C9.07642 16.7343 7.1218 14.8944 5.37063 11.8616C3.61788 8.82474 3.00196 6.20907 3.57038 4.01378C3.69798 3.52005 3.95061 3.06751 4.30392 2.69977C4.65723 2.33204 5.09852 2.06152 5.58676 1.91428ZM5.93034 3.05191C5.63733 3.14003 5.37197 3.30213 5.15981 3.52261C4.94766 3.74308 4.79588 4.01448 4.71909 4.31066C4.24251 6.15682 4.78796 8.47562 6.3998 11.2678C8.01005 14.0561 9.74301 15.6877 11.5773 16.1999C11.8736 16.2825 12.1863 16.287 12.4848 16.213C12.7834 16.1389 13.0577 15.9887 13.281 15.7772L13.9824 15.1122C14.1564 14.9473 14.2647 14.7249 14.2871 14.4863C14.3095 14.2477 14.2446 14.009 14.1043 13.8146L13.091 12.4094C12.97 12.2417 12.7997 12.1161 12.6037 12.0503C12.4078 11.9844 12.1961 11.9815 11.9985 12.0421L10.4033 12.5305C9.47701 12.806 8.63705 12.0611 7.73455 10.4975C7.12496 9.44462 6.84155 8.6292 6.9128 7.99507C6.94921 7.66574 7.1028 7.36174 7.34426 7.13532L8.5278 6.03253C8.67889 5.89153 8.78205 5.70677 8.8228 5.50416C8.86355 5.30155 8.83984 5.09127 8.75501 4.90282L8.04171 3.31474C7.94315 3.0956 7.76822 2.91981 7.54956 2.82017C7.33091 2.72053 7.08347 2.70385 6.85342 2.77324L5.93034 3.05191Z"
                fill="white" />
            </svg>
          </a>

          <a href="#" aria-label="email" target="_blank" class="social">
            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
              <path
                d="M4.15629 3.16675H14.8438C15.501 3.16671 16.1333 3.41814 16.611 3.86949C17.0887 4.32083 17.3755 4.93786 17.4127 5.594L17.4167 5.73966V13.2605C17.4167 13.9177 17.1653 14.55 16.714 15.0277C16.2626 15.5054 15.6456 15.7923 14.9895 15.8295L14.8438 15.8334H4.15629C3.4991 15.8335 2.8668 15.582 2.38911 15.1307C1.91141 14.6793 1.62454 14.0623 1.58733 13.4062L1.58337 13.2605V5.73966C1.58333 5.08247 1.83477 4.45018 2.28611 3.97248C2.73746 3.49479 3.35449 3.20791 4.01062 3.17071L4.15629 3.16675ZM16.2292 7.42037L9.77712 10.8166C9.70427 10.8551 9.6242 10.878 9.54202 10.8839C9.45983 10.8897 9.37733 10.8784 9.29975 10.8507L9.22375 10.8174L2.77087 7.42116V13.2605C2.77089 13.6082 2.90163 13.9432 3.13716 14.1989C3.37269 14.4547 3.69578 14.6126 4.04229 14.6412L4.15629 14.6459H14.8438C15.1916 14.6459 15.5267 14.515 15.7825 14.2793C16.0383 14.0436 16.196 13.7204 16.2245 13.3737L16.2292 13.2605V7.42037ZM14.8438 4.35425H4.15629C3.8086 4.35426 3.47362 4.48501 3.21786 4.72054C2.96209 4.95606 2.80423 5.27915 2.77562 5.62566L2.77087 5.73966V6.07929L9.50004 9.62121L16.2292 6.0785V5.73966C16.2292 5.39185 16.0983 5.05676 15.8626 4.80098C15.6269 4.54519 15.3037 4.38742 14.957 4.359L14.8438 4.35425Z"
                fill="white" />
            </svg>
          </a>
          <a href="#" target="_blank" class="social" aria-label="whatsapp">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
              <path
                d="M11.0367 1.83331C6.03165 1.83331 1.95248 5.91247 1.95248 10.9175C1.95248 12.5216 2.37415 14.08 3.16248 15.455L1.87915 20.1666L6.69165 18.9016C8.02082 19.6258 9.51498 20.0108 11.0367 20.0108C16.0417 20.0108 20.1208 15.9316 20.1208 10.9266C20.1208 8.49747 19.1767 6.21497 17.4625 4.50081C16.6221 3.65191 15.6211 2.97884 14.5178 2.52085C13.4146 2.06287 12.2312 1.82915 11.0367 1.83331ZM11.0458 3.36414C13.0625 3.36414 14.9508 4.15247 16.3808 5.58247C17.0826 6.28405 17.639 7.11726 18.0181 8.03434C18.3972 8.95141 18.5916 9.9343 18.59 10.9266C18.59 15.0883 15.1983 18.4708 11.0367 18.4708C9.67998 18.4708 8.35082 18.1133 7.19582 17.4166L6.92082 17.2608L4.06082 18.0125L4.82165 15.2258L4.63832 14.9325C3.8811 13.7304 3.48058 12.3381 3.48332 10.9175C3.49248 6.75581 6.87498 3.36414 11.0458 3.36414ZM7.81915 6.71914C7.67248 6.71914 7.42498 6.77414 7.21415 7.00331C7.01248 7.23247 6.41665 7.79164 6.41665 8.90081C6.41665 10.0191 7.23248 11.0916 7.33332 11.2475C7.46165 11.4033 8.94665 13.695 11.2292 14.6666C11.77 14.9141 12.1917 15.0516 12.5217 15.1525C13.0625 15.3266 13.5575 15.2991 13.9517 15.2441C14.3917 15.18 15.29 14.6941 15.4825 14.1625C15.675 13.6308 15.675 13.1816 15.62 13.0808C15.5558 12.9891 15.4092 12.9341 15.18 12.8333C14.9508 12.705 13.8325 12.155 13.6308 12.0816C13.42 12.0083 13.2917 11.9716 13.1175 12.1916C12.9708 12.4208 12.5308 12.9341 12.4025 13.0808C12.265 13.2366 12.1367 13.255 11.9167 13.145C11.6783 13.0258 10.945 12.7875 10.0833 12.0175C9.40498 11.4125 8.95582 10.67 8.81832 10.4408C8.70832 10.2208 8.80915 10.0833 8.91915 9.98247C9.01998 9.88164 9.16665 9.71664 9.25832 9.57914C9.37748 9.45081 9.41415 9.34997 9.48748 9.20331C9.56082 9.04747 9.52415 8.91914 9.46915 8.80914C9.41415 8.70831 8.95582 7.57164 8.76332 7.12247C8.57998 6.68247 8.39665 6.73747 8.24998 6.72831C8.12165 6.72831 7.97498 6.71914 7.81915 6.71914Z"
                fill="white" />
            </svg>
          </a>
          <span style="width: 1px; height: 30px; background-color: #f6f5f5">|</span>
          <!-----------Language Button for Large Screens----------------->
          <button @click="changeLanguage" class="social language-btn" aria-label="language">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path
                d="M7.74999 2.75C7.74999 2.55109 7.67097 2.36032 7.53032 2.21967C7.38967 2.07902 7.1989 2 6.99999 2C6.80108 2 6.61031 2.07902 6.46966 2.21967C6.32901 2.36032 6.24999 2.55109 6.24999 2.75V4.008C5.04615 4.03491 3.84468 4.12771 2.65099 4.286C2.55335 4.299 2.45923 4.33111 2.374 4.38048C2.28877 4.42986 2.2141 4.49554 2.15425 4.57377C2.0944 4.652 2.05055 4.74126 2.0252 4.83644C1.99984 4.93162 1.99349 5.03086 2.00649 5.1285C2.01949 5.22614 2.05159 5.32026 2.10097 5.40549C2.15034 5.49072 2.21602 5.56539 2.29426 5.62524C2.37249 5.68508 2.46175 5.72894 2.55693 5.75429C2.65211 5.77964 2.75135 5.786 2.84899 5.773C4.78803 5.51576 6.7468 5.43943 8.69999 5.545C8.28614 6.94302 7.71587 8.28987 6.99999 9.56C6.62609 8.8969 6.29152 8.21238 5.99799 7.51C5.91798 7.3317 5.77153 7.19166 5.58982 7.11972C5.40811 7.04777 5.2055 7.04959 5.02512 7.1248C4.84473 7.2 4.70083 7.34265 4.62404 7.52236C4.54725 7.70208 4.54364 7.90467 4.61399 8.087C5.03468 9.09442 5.53354 10.0674 6.10599 10.997C5.03712 12.5591 3.74775 13.9583 2.27799 15.151C2.19815 15.2119 2.13134 15.2882 2.08154 15.3754C2.03174 15.4626 1.99995 15.5589 1.98806 15.6586C1.97618 15.7583 1.98443 15.8594 2.01234 15.9558C2.04024 16.0523 2.08723 16.1421 2.15052 16.2201C2.21381 16.298 2.2921 16.3625 2.38077 16.4096C2.46943 16.4568 2.56665 16.4856 2.66667 16.4944C2.76669 16.5033 2.86747 16.492 2.96303 16.4612C3.05859 16.4303 3.14699 16.3806 3.22299 16.315C4.64999 15.157 5.91972 13.8177 6.99999 12.331C7.09499 12.463 7.19199 12.593 7.28999 12.722C7.41066 12.8803 7.58929 12.9842 7.78658 13.0109C7.98387 13.0375 8.18365 12.9847 8.34199 12.864C8.50032 12.7433 8.60423 12.5647 8.63086 12.3674C8.65749 12.1701 8.60466 11.9703 8.48399 11.812C8.28015 11.5456 8.08341 11.2738 7.89399 10.997C8.91667 9.33725 9.70196 7.5425 10.227 5.665C10.537 5.696 10.845 5.733 11.151 5.773C11.3482 5.79926 11.5477 5.7461 11.7057 5.62524C11.8637 5.50437 11.9672 5.32569 11.9935 5.1285C12.0197 4.93131 11.9666 4.73177 11.8457 4.57377C11.7249 4.41577 11.5462 4.31226 11.349 4.286C10.1553 4.1274 8.95384 4.0346 7.74999 4.008V2.75Z"
                fill="white" />
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M13 8C13.1394 8 13.276 8.03884 13.3945 8.11214C13.513 8.18544 13.6088 8.29032 13.671 8.415L17.921 16.915C17.9659 17.0032 17.9929 17.0994 18.0005 17.1981C18.008 17.2968 17.9959 17.396 17.9649 17.49C17.9339 17.5841 17.8847 17.671 17.8199 17.7459C17.7551 17.8207 17.6762 17.882 17.5877 17.9262C17.4991 17.9705 17.4027 17.9967 17.3039 18.0035C17.2052 18.0102 17.106 17.9974 17.0123 17.9657C16.9185 17.9339 16.832 17.884 16.7576 17.8186C16.6833 17.7533 16.6226 17.6739 16.579 17.585L15.787 16H10.214L9.42104 17.585C9.37752 17.6739 9.31683 17.7533 9.24247 17.8186C9.16811 17.884 9.08156 17.9339 8.98779 17.9657C8.89403 17.9974 8.79492 18.0102 8.69617 18.0035C8.59742 17.9967 8.50098 17.9705 8.41243 17.9262C8.32387 17.882 8.24494 17.8207 8.18018 17.7459C8.11543 17.671 8.06614 17.5841 8.03515 17.49C8.00416 17.396 7.99208 17.2968 7.99961 17.1981C8.00715 17.0994 8.03414 17.0032 8.07904 16.915L12.329 8.415C12.3913 8.29032 12.487 8.18544 12.6056 8.11214C12.7241 8.03884 12.8607 8 13 8ZM15.037 14.5L13 10.427L10.964 14.5H15.037Z"
                fill="white" />
            </svg>
          </button>
        </div>

        <!-------Language button for small screens----------------------->
        <p class="info p-0">
          <button id="language-btn" class="social d-lg-none language-btn" @click="changeLanguage" aria-label="language">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path
                d="M7.74999 2.75C7.74999 2.55109 7.67097 2.36032 7.53032 2.21967C7.38967 2.07902 7.1989 2 6.99999 2C6.80108 2 6.61031 2.07902 6.46966 2.21967C6.32901 2.36032 6.24999 2.55109 6.24999 2.75V4.008C5.04615 4.03491 3.84468 4.12771 2.65099 4.286C2.55335 4.299 2.45923 4.33111 2.374 4.38048C2.28877 4.42986 2.2141 4.49554 2.15425 4.57377C2.0944 4.652 2.05055 4.74126 2.0252 4.83644C1.99984 4.93162 1.99349 5.03086 2.00649 5.1285C2.01949 5.22614 2.05159 5.32026 2.10097 5.40549C2.15034 5.49072 2.21602 5.56539 2.29426 5.62524C2.37249 5.68508 2.46175 5.72894 2.55693 5.75429C2.65211 5.77964 2.75135 5.786 2.84899 5.773C4.78803 5.51576 6.7468 5.43943 8.69999 5.545C8.28614 6.94302 7.71587 8.28987 6.99999 9.56C6.62609 8.8969 6.29152 8.21238 5.99799 7.51C5.91798 7.3317 5.77153 7.19166 5.58982 7.11972C5.40811 7.04777 5.2055 7.04959 5.02512 7.1248C4.84473 7.2 4.70083 7.34265 4.62404 7.52236C4.54725 7.70208 4.54364 7.90467 4.61399 8.087C5.03468 9.09442 5.53354 10.0674 6.10599 10.997C5.03712 12.5591 3.74775 13.9583 2.27799 15.151C2.19815 15.2119 2.13134 15.2882 2.08154 15.3754C2.03174 15.4626 1.99995 15.5589 1.98806 15.6586C1.97618 15.7583 1.98443 15.8594 2.01234 15.9558C2.04024 16.0523 2.08723 16.1421 2.15052 16.2201C2.21381 16.298 2.2921 16.3625 2.38077 16.4096C2.46943 16.4568 2.56665 16.4856 2.66667 16.4944C2.76669 16.5033 2.86747 16.492 2.96303 16.4612C3.05859 16.4303 3.14699 16.3806 3.22299 16.315C4.64999 15.157 5.91972 13.8177 6.99999 12.331C7.09499 12.463 7.19199 12.593 7.28999 12.722C7.41066 12.8803 7.58929 12.9842 7.78658 13.0109C7.98387 13.0375 8.18365 12.9847 8.34199 12.864C8.50032 12.7433 8.60423 12.5647 8.63086 12.3674C8.65749 12.1701 8.60466 11.9703 8.48399 11.812C8.28015 11.5456 8.08341 11.2738 7.89399 10.997C8.91667 9.33725 9.70196 7.5425 10.227 5.665C10.537 5.696 10.845 5.733 11.151 5.773C11.3482 5.79926 11.5477 5.7461 11.7057 5.62524C11.8637 5.50437 11.9672 5.32569 11.9935 5.1285C12.0197 4.93131 11.9666 4.73177 11.8457 4.57377C11.7249 4.41577 11.5462 4.31226 11.349 4.286C10.1553 4.1274 8.95384 4.0346 7.74999 4.008V2.75Z"
                fill="white" />
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M13 8C13.1394 8 13.276 8.03884 13.3945 8.11214C13.513 8.18544 13.6088 8.29032 13.671 8.415L17.921 16.915C17.9659 17.0032 17.9929 17.0994 18.0005 17.1981C18.008 17.2968 17.9959 17.396 17.9649 17.49C17.9339 17.5841 17.8847 17.671 17.8199 17.7459C17.7551 17.8207 17.6762 17.882 17.5877 17.9262C17.4991 17.9705 17.4027 17.9967 17.3039 18.0035C17.2052 18.0102 17.106 17.9974 17.0123 17.9657C16.9185 17.9339 16.832 17.884 16.7576 17.8186C16.6833 17.7533 16.6226 17.6739 16.579 17.585L15.787 16H10.214L9.42104 17.585C9.37752 17.6739 9.31683 17.7533 9.24247 17.8186C9.16811 17.884 9.08156 17.9339 8.98779 17.9657C8.89403 17.9974 8.79492 18.0102 8.69617 18.0035C8.59742 17.9967 8.50098 17.9705 8.41243 17.9262C8.32387 17.882 8.24494 17.8207 8.18018 17.7459C8.11543 17.671 8.06614 17.5841 8.03515 17.49C8.00416 17.396 7.99208 17.2968 7.99961 17.1981C8.00715 17.0994 8.03414 17.0032 8.07904 16.915L12.329 8.415C12.3913 8.29032 12.487 8.18544 12.6056 8.11214C12.7241 8.03884 12.8607 8 13 8ZM15.037 14.5L13 10.427L10.964 14.5H15.037Z"
                fill="white" />
            </svg>
          </button>
        </p>
        <div class="d-flex gap-3 gap-lg-4 info p-0 flex-wrap">
          <router-link :to="{ path: `/${$i18n.locale}/join-us` }" class="nav-link-1 exact d-none d-lg-inline-block"> {{
            $t('join_us') }}
          </router-link>
          <router-link :to="{ path: `/${$i18n.locale}/community` }" class="nav-link-1 exact"> {{ $t('community') }}
          </router-link>
          <router-link :to="{ path: `/${$i18n.locale}/reviews` }" class="nav-link-1 exact"> {{ $t('reviews') }}
          </router-link>
          <router-link :to="{ path: `/${$i18n.locale}/partners` }" class="nav-link-1 exact"> {{ $t('partners') }}
          </router-link>
          <router-link :to="{ path: `/${$i18n.locale}/clients` }" class="nav-link-1 exact"> {{ $t('clients') }}
          </router-link>
        </div>
      </div>
      <hr />
    </div>
  </header>
</template>

<script>
import { mapActions } from 'vuex';
import store from '@/store';
export default {
  name: "Navbar",
  data() {
    return {

    };
  },
  props: ["isSpecialStyling"],
  methods: {
    ...mapActions(['updateLanguage']),

    //change Language
    changeLanguage() {
      let language = ''
      if (store.getters.currentLanguage == 'ar')
        language = 'en';
      else language = 'ar';
      this.$i18n.locale = language;
      this.showLanguageMenu = false;

      if (language == 'ar') {
        document.body.dir = 'rtl';
        localStorage.setItem('direction', document.body.dir)
        this.$store.commit('SET_LANGUAGE', 'ar')

      } else {
        document.body.dir = 'ltr';
        localStorage.setItem('direction', document.body.dir);
        this.$store.commit('SET_LANGUAGE', 'en')
      }
      // Update the route to include the new language
      this.$router.push({
        path: `/${language}${this.$route.path.replace(/^\/(en|ar)/, '')}`
      });
      this.updateLanguage(language);
      this.$parent.language = language;
      localStorage.setItem('language', language);
      this.$parent.$emit('language-changed', language);

      window.dispatchEvent(new CustomEvent('direction-localstorage-changed', {
        detail: {
          storage: localStorage.getItem('direction')
        }
      }));
    }
  }
};
</script>
<style lang="scss" scoped>
// .language-btn {
//   animation: moveTopToBottom 3s ease-in-out infinite;
// }

// @keyframes moveTopToBottom {
//   0% {
//     transform: translateY(0)
//   }

//   50% {
//     transform: translateY(10px)
//   }

//   100% {
//     transform: translateY(0)
//   }
// }

/***********************/
.overlay {
  position: relative;
}

.header {
  background-color: transparent;
  color: #fff;
  font-size: 1rem;
}

a.active {
  color: #2EA2CE !important;
  font-size: .875rem;
  font-weight: 700 !important;
}

.top-box {
  width: 50px;
  height: 44px;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  opacity: 0.1;
  background: #2EA2CE;
  position: absolute;
  top: -5px;

  &:lang(ar) {
    right: -10px;
  }

  &:lang(en) {
    left: -10px;
  }
}

.social {
  width: 35px;
  height: 35px;
  border-radius: 23.5px;
  background-color: #206387;
  -webkit-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  border: 1px solid #206387;

  &:hover {
    background: transparent;

    svg {
      path {
        fill: #206387;
      }
    }
  }
}

.header .line {
  width: 3px;
  height: 50px;
  background-color: #fff;
  margin: 0 5px;
}

header {
  p {
    cursor: pointer;
  }

  .info {
    padding: 15px 30px;

    &>a {
      cursor: pointer;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      gap: 5px;
      text-decoration: none;
      color: #fff;
      font-family: "Almarai", sans-serif;
      font-size: .875rem;
      -webkit-transition: 0.5s;
      -o-transition: 0.5s;
      transition: 0.5s;

      &:hover {
        cursor: pointer;
        -webkit-transform: translateY(5px);
        -ms-transform: translateY(5px);
        transform: translateY(5px);

        svg {
          path {
            fill: #206387
          }
        }
      }
    }
  }
}

hr {
  background: #ebebeb;
  height: 2px;
  border: 1px solid #ebebeb;
  margin-top: 2px;
}

.special-navbar {
  .info a {
    color: #37474F;
  }
}

/**************************/
header .info>a {
  &.router-link-exact-active {
    color: #2EA2CE;
    font-weight: 700;
  }
}

@media screen and (max-width :992px) {
  header {
    .info {
      margin-top: 10px;
      height: 35px;

      &>a {
        color: #000;
        font-size: .975rem;
      }
    }
  }


}
</style>
